import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getRegulationsStagesPlanWorksRecomendedEquipment(options = {}) {
	return _apiRequestWrap(
		ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT,
		ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT]
			.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT]
		.GET_REGULATIONS_STAGES_PLAN_WORKS_RECOMENDED_EQUIPMENT]: _getRegulationsStagesPlanWorksRecomendedEquipment,
}
